@use "sass:color";
@import "../../colors.scss";

.container {
  height: calc(($ARTICLE_WIDTH) / 2 - 2rem);
  width: 4rem;
  margin: 2rem 3rem;
  font-family: $MONOSPACE_FONT;
  overflow: visible;
  background-color: $ACCENT_ALT;
  box-shadow: $BOX_SHADOW;
  border-radius: $BORDER_RADIUS;
}

.leftLetter.highlighted {
  transition: color 0.1s, font-size 0.1s, x 0.1s;
  color: green;
  font-size: 2rem;
}

.rightLetter.highlighted {
  transition: color 0.1s, font-size 0.1s, x 0.1s;
  color: red;
  font-size: 2rem;
}

.link {
  opacity: 0.3;
  transition: opacity 0.1s, stroke-width 0.1s, d 0.4s;
  stroke-width: 1px;

  &.highlighted {
    opacity: 1;
    stroke-width: 3px;

    @keyframes dash {
      from {
        stroke-dashoffset: 200;
      }
      to {
        stroke-dashoffset: 0;
      }
    }

    stroke-dasharray: 20;
    animation: dash 1.5s linear infinite;
  }
}
